import Funnels from './Funnels';

const routes = [{
  path: 'funnels',
  component: Funnels,
  label: 'Funnels',
}];

export default routes;
